const ASC = 'asc';
const DESC = 'desc';

export const sortDirection = {
  ASC,
  DESC
}